import {
  navigateToUrl,
  registerApplication,
  start,
  addErrorHandler,
  LOAD_ERROR,
  getAppStatus,
  AppError,
  removeErrorHandler,
} from 'single-spa'
import {
  constructApplications,
  constructLayoutEngine,
  constructRoutes,
} from 'single-spa-layout'

import {
  getCustomerStatus,
  getSession,
  getUserInfo,
  logout,
} from './utils/security'
import { setUserLocale } from './utils/i18n'

import microfrontendLayout from './microfrontend-layout.html'

import './tailwind.css'
import '@munditrade/design-system/dist/main.css'
import '@munditrade/component-library/dist/main.css'
import { redirectMap } from './utils/redirects'
import { LocalStorage } from './utils/constants'
import sentryHubClient from './utils/sentryHubClient'

import { initialSentryOpts } from './sentryConfig'

// Add global variable to register MF sentry hubs
window.sentryHub = {}

// sentry hub client init
const {
  hub,
  errorHandler: sentryErrorHandler,
  startSessionTrackingOnHub,
} = sentryHubClient({
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENV || 'development',
  ...initialSentryOpts,
})

const appErrorHandler = (err: AppError) => {
  if (getAppStatus(err.appOrParcelName) === LOAD_ERROR) {
    // this will try to refetch the app again
    System.delete(System.resolve(err.appOrParcelName))
    sentryErrorHandler(err)
  }
}

const navigationCollapseHandler = () => {
  const isCollapsed = localStorage.getItem(LocalStorage.MAIN_MENU_IS_COLLAPSED)
  const el = document.getElementById('main-content')

  if (isCollapsed !== 'true') {
    el.classList.replace('md:pl-28', 'md:pl-72')
  } else {
    el.classList.replace('md:pl-72', 'md:pl-28')
  }
}

window.removeEventListener('storage', navigationCollapseHandler)

const startApplications = (products: Array<any>) => {
  localStorage.setItem(LocalStorage.PLATFORM, 'cp')
  const data = {
    props: {
      availableProducts: products,
    },
    loaders: {},
  }
  const routes = constructRoutes(microfrontendLayout, {
    ...data,
    props: {
      ...data.props,
    },
  })
  const applications = constructApplications({
    routes,
    loadApp({ name }) {
      return System.import(name)
    },
  })
  const layoutEngine = constructLayoutEngine({ routes, applications })
  layoutEngine.activate()
  applications.forEach(registerApplication)
  startSessionTrackingOnHub()
}

getSession()
  .then(getUserInfo)
  .then(getCustomerStatus)
  .then((products) => {
    setUserLocale()
    addErrorHandler(appErrorHandler)
    startApplications(products)
    start()
    navigationCollapseHandler()
    window.addEventListener('storage', navigationCollapseHandler)
    // Release
    const elLoader = document.getElementById('page-loader')
    elLoader.style.display = 'none'
    const aplication = document.getElementById('aplication')
    aplication.setAttribute('style', 'visibility: visible; display: block;')
    const map = redirectMap
    if (map.get(location.pathname)) navigateToUrl(map.get(location.pathname))
  })
  .catch((e) => {
    sentryErrorHandler(e)
    hub.endSession()
    removeErrorHandler(appErrorHandler)
    logout()

    window.location.replace(
      `${process.env.AUTH_APP_URL}/api/logout?redirectUri=${window.location.href}`
    )
  })
